import { BatchImportRequest, FileDescriptor, Configuration } from '@/api'
import DialogUploadValues from '@/types/dialogUploadValues'
import { MAX_FILE_NAME_LENGTH } from '@/constants/NameLengths'
import { getContentTypeFromFile } from '@/utils'

/**
 * Au-delà de la limite, raccourcit le nom en gardant l'extension, qui dit le type du document.
 * Compte en caractères, comme la base, sans couper un emoji en deux.
 */
const fitFileName = (name: string): string => {
  const chars = Array.from(name)
  if (chars.length <= MAX_FILE_NAME_LENGTH) return name
  const extension = Array.from(/\.[^.]{1,16}$/.exec(name)?.[0] ?? '')
  return (
    chars.slice(0, MAX_FILE_NAME_LENGTH - extension.length).join('') + extension.join('')
  )
}

export interface Args {
  values: DialogUploadValues
  dearchived?: boolean
  configurations?: Pick<Configuration, 'cid' | 'groupId'>[]
}

export default ({ values, dearchived, configurations }: Args) => {
  // Create file descriptors for each file to be uploaded
  const fileDescriptor: FileDescriptor[] = values.files.map((file) => ({
    filename: fitFileName(file.name),
    postscript: false,
    contentType: getContentTypeFromFile(file),
  }))

  // Create a new batch import request
  let groupId = values.group
  if (values.exportConfiguration && configurations?.length) {
    groupId =
      configurations.find((c) => c.cid === values.exportConfiguration)?.groupId ??
      groupId
  }

  const newBatchImport: BatchImportRequest = {
    files: fileDescriptor,
    batchName: values.recordName,
    configurationId:
      values.exportConfiguration && values.exportConfiguration !== ''
        ? values.exportConfiguration
        : null,
    fluxId: values.workflow && values.workflow !== '' ? values.workflow : null,
    groupId,
    dearchived,
    clientOrganizationId:
      values.clientOrganizationId ?? values.clientOrganizationId !== ''
        ? values.clientOrganizationId
        : null,
    tagIds: values.tagIds?.length ? values.tagIds : undefined,
    ...(values.agentic ? { agentic: true } : {}),
  }

  return newBatchImport
}
